<template>
    <div>
        <div class="loading-wrapper">
            <div class="loading">
                <img src="../assets/images/loading.gif" class="loadingGif">
                <p class="desc">{{imgCount}}%</p>
                <p class="loading_desc">LOADING...</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {imgArrList} from '../assets/js/config';

    export default {
        data(){
            return{
                imgCount:0,
            }
        },
        methods:{
            loading(){
                var imgArr = imgArrList;
                var imgCount = this.imgCount;
                for(var img of imgArr){
                    var image = new Image();
                    image.src = img;
                    image.onload = () =>{
                        imgCount++;
                        this.imgCount = parseInt((imgCount/imgArr.length) * 100);
                        if(imgCount === imgArr.length){
                            this.$router.replace('/index1');
                        }
                    }
                }
            },
        },
        mounted(){
            this.loading();
        },
    }
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
    .loading-wrapper
        position absolute
        width 100%
        top 30%
        .loading
            width 100%
            text-align center
            .loadingGif
                width 1.24rem
                height 1.24rem
            .desc,.loading_desc
                line-height: 0.5rem
                font-size: 0.5rem
                color: gray
            .loading_desc
                padding-top .05rem
                line-height: 0.25rem
                font-size: 0.25rem
</style>